import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { getFormattedDate, getLatestDate } from 'dateUtils';
import { getArrayLength, getHasElementsInArray } from 'utils';
import { EMPTY_ARRAY } from 'data/global';

import './ReminderStatusText.styles.scss';

type ReminderStatusTextProps = {
  className?: string;
  reminderDates: (Date | string)[];
};

const ReminderStatusText: React.FC<ReminderStatusTextProps> = ({
  className,
  reminderDates = EMPTY_ARRAY,
}) => {
  const { t } = useTranslation();

  const classes = classNames('reminder-status-text', className);

  if (!getHasElementsInArray(reminderDates))
    return <p className={classes}>{t('noRemindersSentYet')}</p>;

  return (
    <p className={classes}>
      {t('lastRemindedOn', {
        date: getFormattedDate(new Date(getLatestDate(reminderDates))),
      })}{' '}
      {t('reminderHistory', { count: getArrayLength(reminderDates) })}
    </p>
  );
};

export default ReminderStatusText;
